<template>
  <FormContainer>
    <template #title>Mobilité internationale</template>
    <template #content>
      <div
        class="form__bloc"
        style="margin-top: -16px"
      >
        <WrapperToggleSwitch
          id="field_unknown"
          v-model="mobiliteInternationaleModel"
          _label="Mobilité internationale"
          :items="OuiOuNon"
          :required="meta?.contrat?.mobiliteInternationale?.$status === PropertyStatus.Required"
          :alertLabel="meta?.contrat?.mobiliteInternationale?.$messageErreurDirty!!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          v-if="meta.contrat?.lieu?.$status !== PropertyStatus.NotPresent"
          id="field_unknown"
          v-model="lieuModel"
          label="Lieu"
          :required="meta?.contrat?.lieu?.$status === PropertyStatus.Required"
          :alertLabel="meta?.contrat?.lieu?.$messageErreurDirty!!"
          class="col-18 col-sm-36"
          :items="lieuMobiliteItems"
          :readonly
        />
        <WrapperDropdown
          v-else
          label="Lieu"
          class="col-18 col-sm-36"
          :items="lieuMobiliteItems"
          disabled
        />
        <WrapperDropdown
          v-if="meta.contrat?.conditionRealisation?.$status !== PropertyStatus.NotPresent"
          id="field_unknown"
          v-model="conditionRealisationModel"
          label="Condition de réalisation"
          :required="meta?.contrat?.conditionRealisation?.$status === PropertyStatus.Required"
          :alertLabel="meta?.contrat?.conditionRealisation?.$messageErreurDirty!!"
          class="col-18 col-sm-36"
          :items="conditionRealisationItems"
          :readonly
        />
        <WrapperDropdown
          v-else
          label="Condition de réalisation"
          class="col-18 col-sm-36"
          :items="conditionRealisationItems"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { lieuMobiliteItems, conditionRealisationItems } from '@/features/interface/demande/capp/dropdown-items'

  const store = useDemandeCAPPStore()

  const { setupFieldWithKey } = store

  const { meta, readonly } = storeToRefs(store)

  const mobiliteInternationaleModel = setupFieldWithKey<string>('contrat.mobiliteInternationale')
  const lieuModel = setupFieldWithKey<string>('contrat.lieu')
  const conditionRealisationModel = setupFieldWithKey<string>('contrat.conditionRealisation')
</script>
